import { render, staticRenderFns } from "./AdiPaiPrestazioniResidenzialiSemiResidenzialiEdit.vue?vue&type=template&id=1155cb3e"
import script from "./AdiPaiPrestazioniResidenzialiSemiResidenzialiEdit.vue?vue&type=script&lang=js"
export * from "./AdiPaiPrestazioniResidenzialiSemiResidenzialiEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports